module.exports = __webpack_public_path__ + "static/media/flappy_demo.807bcfaa.gif";